<ngb-alert
  [type]="'success'"
  *ngIf="statusMessage && !statusMessage.includes('sentimos')"
>
  {{ statusMessage }}
</ngb-alert>
<ngb-alert
  [type]="'danger'"
  *ngIf="statusMessage && statusMessage.includes('sentimos')"
>
  {{ statusMessage }}
</ngb-alert>

<app-spinner *ngIf="isLoading"></app-spinner>

<div class="card" *ngIf="!isLoading">
  <div class="card-header">
    Listado de neveras

    <form class="form-inline float-right d-none d-md-flex">
      <div class="row">
        <label>Desde:</label>
        <div class="form-group hidden">
          <div class="input-group">
            <input
              name="datepicker"
              class="form-control"
              ngbDatepicker
              #datepicker="ngbDatepicker"
              [autoClose]="'outside'"
              (dateSelect)="onDateSelection($event, true)"
              [displayMonths]="2"
              [dayTemplate]="t"
              outsideDays="hidden"
              [startDate]="fromDate!"
              tabindex="-1"
            />
            <ng-template #t let-date let-focused="focused">
              <span
                class="custom-day"
                [class.focused]="focused"
                [class.range]="isRange(date)"
                [class.faded]="isHovered(date) || isInside(date)"
                (mouseenter)="hoveredDate = date"
                (mouseleave)="hoveredDate = null"
              >
                {{ date.day }}
              </span>
            </ng-template>
          </div>
        </div>
        <div class="form-group">
          <div class="input-group">
            <input
              #dpFromDate
              class="form-control input-calendar"
              placeholder="yyyy-mm-dd"
              name="dpFromDate"
              (click)="datepicker.toggle()"
              [value]="formatter.format(fromDate)"
              (input)="fromDate = validateInput(fromDate, dpFromDate.value)"
            />
            <div class="input-group-append">
              <button
                class="btn btn-outline-secondary fa fa-calendar"
                (click)="datepicker.toggle()"
                type="button"
              ></button>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <label>Hasta:</label>
        <div class="form-group">
          <div class="input-group">
            <input
              #dpToDate
              class="form-control input-calendar"
              placeholder="yyyy-mm-dd"
              name="dpToDate"
              (click)="datepicker.toggle()"
              [value]="formatter.format(toDate)"
              (input)="toDate = validateInput(toDate, dpToDate.value)"
            />
            <div class="input-group-append">
              <button
                class="btn btn-outline-secondary fa fa-calendar"
                (click)="datepicker.toggle()"
                type="button"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="card-body table-card-body">
    <div class="d-block d-md-none pt-1 pb-2 text-center overflow-auto">
      <ngb-datepicker
        #dp
        (dateSelect)="onDateSelection($event, true)"
        [displayMonths]="2"
        [dayTemplate]="t"
        outsideDays="hidden"
      >
      </ngb-datepicker>

      <ng-template #t let-date let-focused="focused">
        <span
          class="custom-day"
          [class.focused]="focused"
          [class.range]="isRange(date)"
          [class.faded]="isHovered(date) || isInside(date)"
          (mouseenter)="hoveredDate = date"
          (mouseleave)="hoveredDate = null"
        >
          {{ date.day }}
        </span>
      </ng-template>
    </div>

    <div *ngIf="!neverasLength" class="text-center pt-3 pb-3">
      <h3>No se han encontrado resultados entre las fechas seleccionadas</h3>
      <h4 class="text-muted">Por favor, seleccione otra fecha</h4>
    </div>

    <div class="float-left">
      <input
        class="form-control"
        placeholder="Buscar en una fecha concreta"
        name="dp"
        ngbDatepicker
        #d="ngbDatepicker"
        style="display: none"
        (dateSelect)="onDateSelection($event, false)"
      />
      <button class="btn btn-light btn-icon" (click)="d.toggle()" type="button">
        Buscar en una fecha concreta<i class="fa fa-search"></i></button
      >&nbsp;
      <button
        class="btn btn-light btn-icon"
        (click)="resetFilters()"
        type="button"
      >
        Borrar filtros<i class="fa fa-eraser"></i>
      </button>
    </div>

    <p *ngIf="neverasLength" class="text-muted float-right">
      <strong>{{ neverasLength }} nevera(s)</strong> en el intervalo
      seleccionado.
    </p>
    <div *ngIf="neverasLength" class="table-responsive">
      <table class="table table-striped">
        <thead class="thead-dark">
          <tr>
            <th scope="col">Imagen</th>
            <th scope="col">Fecha</th>
            <th scope="col">Localidad</th>
            <th scope="col">País</th>
            <th scope="col">Creado por</th>
            <th scope="col">Modificado por</th>
            <th scope="col">Acción</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let nevera of neveras">
            <td
              *ngIf="nevera.image_path"
              [routerLink]="['/neveras/editar', nevera.url_slug]"
            >
              <img
                src="{{
                  imageBaseURL +
                    nevera.image_path.replace('/images/', '/images/xs-')
                }}"
              />
            </td>
            <td *ngIf="!nevera.image_path"></td>
            <td [routerLink]="['/neveras/editar', nevera.url_slug]">
              {{ nevera.nevera_date.substr(0, 10) }}
            </td>
            <td [routerLink]="['/neveras/editar', nevera.url_slug]">
              {{ nevera.ciudad }}
            </td>
            <td [routerLink]="['/neveras/editar', nevera.url_slug]">
              {{ nevera.pais }}
            </td>
            <td
              class="text-muted"
              [routerLink]="['/neveras/editar', nevera.url_slug]"
            >
              {{ nevera.created_by }}
              <span class="text-muted"
                >({{
                  nevera.date_created
                    .substr(0, 16)
                    .replace("T", "&nbsp;&nbsp;")
                }})</span
              >
            </td>
            <td
              class="text-muted"
              [routerLink]="['/neveras/editar', nevera.url_slug]"
            >
              {{ nevera.modified_by }}
              <span class="text-muted"
                >({{
                  nevera.date_last_modified
                    .substr(0, 16)
                    .replace("T", "&nbsp;&nbsp;")
                }})</span
              >
            </td>
            <!--<td>
        {{
          user.date_privacy_accepted.substr(0, 16).replace('T', '&nbsp;&nbsp;')
        }}
      </td>
      <td *ngIf="user.date_last_login">
        {{ user.date_last_login.substr(0, 16).replace('T', '&nbsp;&nbsp;') }}
      </td>
      <td *ngIf="!user.date_last_login">- Nunca -</td>
      <td>{{ user.role_description }}</td>-->
            <td>
              <a
                class="btn btn-sm btn-secondary"
                [routerLink]="['/neveras/editar', nevera.url_slug]"
              >
                Editar
              </a>
              <!--<a
                *ngIf="nevera.url_slug"
                class="btn btn-sm btn-primary"
                target="_blank"
                href="https://app.cookadhoc.com/tabs/neveras/{{
                  nevera.url_slug
                }}"
              >
                Previsualizar
              </a>-->
              <!--&nbsp;<button
          type="button"
          class="btn btn-sm btn-danger"
          (click)="
            onDelete(
              user.user_id,
              user.role_description,
              user.firstname,
              user.surname,
              user.email
            )
          "
        >
          Eliminar
        </button>-->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<ngb-pagination
  *ngIf="neverasLength > pageSize && !isLoading"
  class="d-flex justify-content-center"
  [(page)]="currentPage"
  (pageChange)="onPageChange($event)"
  [pageSize]="pageSize"
  [collectionSize]="neverasLength"
  [boundaryLinks]="false"
  [maxSize]="5"
  [rotate]="true"
></ngb-pagination>
